import { useMemo } from 'react'
import { type PerilFragment } from '@/services/graphql/generated'
import { useProductData } from '../ProductData/ProductDataProvider'

export const useMissingPerils = (perils: Array<PerilFragment>) => {
  const { variants } = useProductData()

  const allPerils = useMemo(() => {
    const perilsMap = new Map(variants.flatMap((item) => item.perils.map((peril) => [peril.title, peril])))
    return Array.from(perilsMap.values())
  }, [variants])

  const items = useMemo(() => {
    return perils.map((item) => ({ id: item.title, ...item }))
  }, [perils])

  const missingItems = useMemo(() => {
    const addedPerils = new Set<string>(items.map((item) => item.id))
    return allPerils.filter((item) => !addedPerils.has(item.title))
  }, [allPerils, items])

  return missingItems
}
